export const getAutocompleteValue = (
  options: any = [],
  value: any = null,
  multiple = false
) => {
  if (!Array.isArray(options)) {
    return multiple ? [] : null;
  }

  if (multiple) {
    if (!options.length || !Array.isArray(value) || !value.length) {
      return [];
    }

    return options.filter(
      (item: any) =>
        value.map((i: any) => (typeof i === 'object' ? i.id : i)).indexOf(item.id) > -1
    );
  }

  if (!options.length || !value) {
    return null;
  }

  return options.find(
    (item: any) => item.id === (typeof value === 'object' ? value?.id : value)
  );
};
